export const VERTICAL_NAME_MAP = {
  'student-loan-refi': 'Student Loan Refinance',
  'student-loan': 'Private Student Loan',
}

export const BANKRATE = 'bankrate'
export const WSJ = 'wsj'
export const NERDWALLET = 'nerdwallet'

export const SUPPORTED_PARTNERS = [BANKRATE, WSJ, NERDWALLET]
